import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Responsive, Spinner } from '~/components';
import { Mobile, Desktop } from './responsive';
import EmptyPage from '~/pages/EmptyPage';

export default function MatchSheet() {
  const {
    selectedMatch: { data: selectedMatch },
    lineup: { data: lineup, loading: isLoading, failed },
    publicFiles,
  } = useSelector(state => state.matches);
  const [optionSelected, setOptionSelected] = useState(1);

  const handleChange = ({ value }) => {
    setOptionSelected(value);
  };
  const matchSheetProps = {
    selectedMatch,
    lineUp: lineup,
    optionSelected,
    handleChange,
    publicFiles,
  };
  if (isLoading) return <Spinner isOpen isRelative />;
  if (Object.keys(lineup).length > 0 && !failed) {
    return (
      <Responsive
        md={<Mobile {...matchSheetProps} />}
        lg={<Desktop {...matchSheetProps} />}
      />
    );
  }
  return <EmptyPage />;
}
